var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeorgia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0454 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95443 31.0454 0.00012207 19.9998 0.00012207C8.95406 0.00012207 -0.000244141 8.95443 -0.000244141 20.0001C-0.000244141 31.0458 8.95406 40.0001 19.9998 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3914H22.6088H22.6087V0.169388C21.7548 0.0582166 20.8841 9.15527e-05 20 9.15527e-05C19.1159 9.15527e-05 18.2452 0.0582166 17.3913 0.169388V17.3913V17.3913H0.169297C0.058125 18.2453 0 19.1159 0 20.0001C0 20.8844 0.058125 21.7549 0.169297 22.6088H17.3912H17.3913V39.8308C18.2452 39.942 19.1159 40.0001 20 40.0001C20.8841 40.0001 21.7548 39.942 22.6087 39.8308V22.6089V22.6088H39.8307C39.9419 21.7549 40 20.8844 40 20.0001C40 19.1159 39.9419 18.2453 39.8307 17.3914V17.3914Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1737 9.56538V6.95663H9.56505V9.56538H6.9563V12.1741H9.56505V14.7827H12.1737V12.1741H14.7824V9.56538H12.1737Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4348 9.56538V6.95663H27.8261V9.56538H25.2174V12.1741H27.8261V14.7827H30.4348V12.1741H33.0435V9.56538H30.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1737 27.8262V25.2176H9.56505V27.8262H6.9563V30.4349H9.56505V33.0437H12.1737V30.4349H14.7824V27.8262H12.1737Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4348 27.8262V25.2176H27.8261V27.8262H25.2174V30.4349H27.8261V33.0437H30.4348V30.4349H33.0435V27.8262H30.4348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgia);
export default __webpack_public_path__ + "static/media/georgia.f7a4e8ac30d92511ad30b83a2ab6784f.svg";
export { ForwardRef as ReactComponent };